import { postJson } from '@helpers/fetch';
import { jsGlobalVars } from '@components/settings';
import { clearNotices, processResponse } from '../registration/form_validation';

const form = document.getElementById('login-form');

const submitEventHandler = (event) => {
    event.preventDefault();

    clearNotices(form);

    const email = form.querySelector('[name="login_email"]').value;
    const password = form.querySelector('[name="login_password"]').value;
    const checkbox = form.querySelector('a[name="remain"]');
    const checkboxFormElement = form.querySelector('input[name="remain"]');
    const remain = checkbox?.classList.contains('checked') ? 1 : 0;
    if (checkboxFormElement) {
        checkboxFormElement.value = String(remain);
    }

    if (jsGlobalVars?.mfaTotpUrl) {
        postJson(
            jsGlobalVars.mfaTotpUrl,
            {
                login_email: email,
                login_password: password,
                remain,
            },
            true,
        ).then((response) => {
            let error = null;

            if (response?.data?.errors) {
                error = response.data.errors;
            } else if (response?.error?.msg) {
                error = {
                    login_email: response.error?.msg,
                    login_password: response.error?.msg,
                };
            }

            if (error) {
                processResponse(
                    {
                        error,
                    },
                    form,
                );

                return;
            }

            const loginContent = document.getElementById('login-content');
            if (loginContent && response?.data?.tpl) {
                loginContent.innerHTML = response?.data?.tpl;
                loginContent.querySelector('[name="login_code"]')?.focus();
            }

            if (!response?.data.length && !response?.error?.msg) {
                form.submit();
            }
        });
    }
};

if (form) {
    form.dataset.key = 'login';
    form.addEventListener('submit', submitEventHandler);
}
